<template>
  <div :class="`grid c_${component.id}__inner_container c_${component.id}__inner_container_${theme_id ?? ''}`">
    <!-- Product name -->
    <div :class="`grid c_${component?.id}__heading c_${component?.id}__heading_${theme_id ?? ''}`">
        <div :class="`grid c_${component?.subcomponents?.heading?.id}__outer_container c_${component?.subcomponents?.heading?.id}__outer_container_${theme_id ?? ''}`">
            <div :class="`grid c_${component?.subcomponents?.heading?.id}__inner_container c_${component?.subcomponents?.heading?.id}__inner_container_${theme_id ?? ''}`">
                <h2 :class="`grid c_${component?.subcomponents?.heading?.id}__heading c_${component?.subcomponents?.heading?.id}__heading_${theme_id ?? ''}`">
                        {{ product.name }}
                </h2>    
            </div>
        </div>
    </div> 
                        
    <!-- Headline -->
    <p :class="`grid c_${component?.id}__headline c_${component?.id}__headline_${theme_id ?? ''}`">
            {{ product.headline }}
    </p>


    <!-- Price -->
    <div :class="`grid c_${component?.id}__price c_${component?.id}__price_${theme_id ?? ''}`">
      <div :class="`grid c_${component?.id}__current_price c_${component?.id}__current_price_${theme_id ?? ''}`"  v-if="price">
        <span v-if="!special_price">${{ formatPrice(price) }}</span>
        <span v-if="special_price"> ${{ formatPrice(special_price) }} </span>
      </div>
      <div :class="`grid c_${component?.id}__current_price c_${component?.id}__current_price_${theme_id ?? ''}`" v-else>
        No Option Selected
      </div>
      <span :class="`c_${component?.id}__regular_price c_${component?.id}__regular_price_${theme_id ?? ''}`"  v-if="special_price && special_price < price"
        >${{ formatPrice(price) }}
      </span>
      <span :class="`c_${component?.id}__current_price_suffix c_${component?.id}__current_price_suffix_${theme_id ?? ''}`" >
        <span v-if="special_price && product.order_quantity > 1">
          for {{ product.order_quantity }} until {{ expiryDate() }}
        </span>
      
        <span v-else-if="special_price">until {{ expiryDate() }}</span>
        <span v-else-if="!special_price && product.order_quantity > 1">
          for {{ product.order_quantity }}
        </span>
      </span>
      <div v-if="special" :class="`c_${component?.id}__special_label c_${component?.id}__special_label_${theme_id ?? ''}`">
        {{ special.label }}
      </div>
      <div v-if="special" :class="`c_${component?.id}__special_disclaimer c_${component?.id}__special_disclaimer_${theme_id ?? ''}`">
        {{ special.disclaimer }}
      </div>
      <div :class="`c_${component?.id}__payment_widgets c_${component?.id}__payment_widgets_${theme_id ?? ''}`"
      v-if="widgetPrice && (transaction_settings?.settings?.payment_options?.zip?.active ?? false)">
        <zip-widget :amount="widgetPrice" :load="true"></zip-widget>
      </div>
  </div>

    <!-- Stock Status -->
    <div :class="`grid c_${component?.id}__stock_status c_${component?.id}__stock_status_${theme_id ?? ''}`">
      <h3 :class="`flex c_${component?.id}__stock_status_heading c_${component?.id}__stock_status_heading_${theme_id ?? ''}`">
        <span>Stock Status</span>
        <selection-option-info :info="page_settings.settings.stock_status_info"></selection-option-info>
      </h3>
      <div>
        <span
          class="flex flex-col"
          :class="statusSpanClasses"
          >{{ stock_status }}
            <span class="text-xxxs" v-if="stock_status == 'On Order'">ETA {{ eta }}</span
          >
          </span>
      </div>
    </div>

    <!-- sku selection section -->
    <div
      v-if="
        product.current_skus && product.current_skus.length && product.order_quantity === 1
      "
      :class="`grid c_${component.id}__sku_selection_section c_${component.id}__sku_selection_section_${theme_id ?? ''}`"
    >
      <div :class="`grid c_${component.subcomponents.sku_selection_section.id}__container c_${component.subcomponents.sku_selection_section.id}__container_${theme_id ?? ''}`">
        <div :class="`grid c_${component.subcomponents.sku_selection_section.id}__selection_options_container c_${component.subcomponents.sku_selection_section.id}__selection_options_container_${theme_id ?? ''}`">
    
          <div v-for="so in selection_options" :key="so.id">
            <h3 class="font-bold text-gray-700 flex gap-2 items-center">
              <span>{{ so.name }}</span>
              <selection-option-info
                :info="so.info"
                v-if="so.info"
              ></selection-option-info>
            </h3>
            <div v-if="so.name === 'Colour'" class="flex gap-1 flex-wrap">

              <div :class="`grid c_${component.subcomponents.sku_selection_section.subcomponents.button.id}__outer_container c_${component.subcomponents.sku_selection_section.subcomponents.button.id}__outer_container_${theme_id ?? ''}`"
                v-for="(value, index) in so.values"
                :key="index"
              >
                <button
                  type="button"
                  :class="`c_${component.subcomponents.sku_selection_section.subcomponents.button.id}__button c_${component.subcomponents.sku_selection_section.subcomponents.button.id}__button_${theme_id ?? ''} ${so.selected === value ? `c_${component.subcomponents.sku_selection_section.subcomponents.button.id}__button_active` : ''}`"
                  :style="`${colourBG(value)}`"
                  @click.prevent="selectOption(0, so, value)"
                >
                  
                </button>
              </div>
            </div>
            <div
              v-else-if="
                ['Size', 'Material', 'Pattern', 'Width'].includes(so.name)
              "
              class="flex flex-wrap gap-2"
            >
              <div :class="`grid c_${component.subcomponents.sku_selection_section.subcomponents.button.id}__outer_container c_${component.subcomponents.sku_selection_section.subcomponents.button.id}__outer_container_${theme_id ?? ''}`"
                v-for="(value, index) in so.values"
                :key="index"
              >
                <button
                  type="button"
                  :class="`c_${component.subcomponents.sku_selection_section.subcomponents.button.id}__button c_${component.subcomponents.sku_selection_section.subcomponents.button.id}__button_${theme_id ?? ''} ${so.selected === value ? `c_${component.subcomponents.sku_selection_section.subcomponents.button.id}__button_active` : ''}`"
                  @click.prevent="selectOption(0, so, value)"
                >
                {{ value }}
                </button>
              </div>  
            </div>
          </div>
        </div>
      </div>
        <div :class="`grid c_${component.subcomponents.sku_selection_section.id}__sku_select c_${component.subcomponents.sku_selection_section.id}__sku_select_${theme_id ?? ''}`">

          <div :class="`grid c_${component.subcomponents.sku_selection_section.subcomponents.form_input.id}__outer_container c_${component.subcomponents.sku_selection_section.subcomponents.form_input.id}__outer_container_${theme_id ?? ''}`">
            <select
            :class="`c_${component.subcomponents.sku_selection_section.subcomponents.form_input.id}__input c_${component.subcomponents.sku_selection_section.subcomponents.form_input.id}__input_${theme_id ?? ''}`"
              v-model.number="selected_sku_id"
              @input="() => selectSku(null)"
            >
              <option
                :value="item.id"
                v-for="item in product.current_skus"
                :key="item.id"
              >
                {{ item.display_name }}
              </option>
            </select>
            <span
            :class="`grid c_${component.subcomponents.sku_selection_section.subcomponents.form_input.id}__error c_${component.subcomponents.sku_selection_section.subcomponents.form_input.id}__error_${theme_id ?? ''}`"
              role="alert"
              v-if="errors['selected_sku_id']"
            >
              {{ errors['selected_sku_id'] }}
            </span>
          </div>
        </div>
      </div>

    
    <!-- Purchase Addon Section -->
    <div
    :class="`grid c_${component.id}__purchase_addon_section c_${component.id}__purchase_addon_section_${theme_id ?? ''}`"
      v-if="purchase_addons.length"
    >
        <div 
        v-for="addon in purchase_addons" :key="addon.id"
        :class="`grid c_${component.subcomponents.purchase_addon_select.id}__outer_container c_${component.subcomponents.purchase_addon_select.id}__outer_container_${theme_id ?? ''}`" 
      >
        <div :class="`grid c_${component.subcomponents.purchase_addon_select.id}__inner_container c_${component.subcomponents.purchase_addon_select.id}__inner_container_${theme_id ?? ''}`">
          <span :class="`flex c_${component.subcomponents.purchase_addon_select.id}__checkbox c_${component.subcomponents.purchase_addon_select.id}__checkbox_${theme_id ?? ''}`">
            <input
            :id="`addon_${addon.id}`"
              type="checkbox"
              value="true"
              v-model="addon.selected"
              class="checkbox"
            />
  
            <label
            :for="`addon_${addon.id}`"
            class="ml-2"
              >
              Add {{ addon.name }} for ${{ formatPrice(addon.price) }}
            </label>
          </span>

        </div>
      </div>
    </div>

    <!-- Customer Input -->
    <div :class="`grid c_${component.id}__customer_input c_${component.id}__customer_input_${theme_id ?? ''} c_${component.subcomponents.form_input.id}__outer_container c_${component.subcomponents.form_input.id}__outer_container_${theme_id ?? ''}`" 
    v-if="product.requires_customer_input">
      <div :class="`grid c_${component.subcomponents.form_input.id}__outer_container c_${component.subcomponents.form_input.id}__outer_container_${theme_id ?? ''}`">
          <label for="customer_content" :class="`grid c_${component.subcomponents.form_input.id}__label c_${component.subcomponents.form_input.id}__label_${theme_id ?? ''}`">
            {{ product.customer_input_label }}<sup class="text-red-600">*</sup>
          </label>

          <input
            id="customer_content"
            ref="customer_content"
            type="text"
            v-model="customer_content"
            :class="`grid c_${component.subcomponents.form_input.id}__input c_${component.subcomponents.form_input.id}__input_${theme_id ?? ''}`"
          />

          <p v-if="errors['customer_content']"  :class="`grid c_${component.subcomponents.form_input.id}__error c_${component.subcomponents.form_input.id}__error_${theme_id ?? ''}`" role="alert">
                {{ errors['customer_content'] }}
          </p>
      </div>
    </div>
    <div v-else></div>

    <!-- Cross Sale Products Section -->
    <div
    :class="`grid c_${component.id}__cross_sale_products_section c_${component.id}__cross_sale_products_section_${theme_id ?? ''}`"
      v-if="cross_sale_products.length"
    >
      <div
        v-for="(csp) in cross_sale_products"
        :key="csp.id"
        class="grid containable"
      >
        <cross-sale-product-card :cross_sale_product="csp" :errors="errors" :component="component.subcomponents.cross_sale_product_select" :theme_id="theme_id"></cross-sale-product-card>
      </div>
    </div>
    <div v-else></div>

<!-- Postcode -->
    <div :class="`grid c_${component.id}__postcode c_${component.id}__postcode_${theme_id ?? ''}`">
      <div :class="`grid c_${component.subcomponents.form_input.id}__outer_container c_${component.subcomponents.form_input.id}__outer_container_${theme_id ?? ''}`">
        <label for="postcode" :class="`grid c_${component.subcomponents.form_input.id}__label c_${component.subcomponents.form_input.id}__label_${theme_id ?? ''}`">
          Shipping Address Postcode<sup class="text-red-600">*</sup>
        </label>

        <input
          id="postcode"
          ref="postcode"
          type="text"
          v-model="postcode"
          :class="`grid c_${component.subcomponents.form_input.id}__input c_${component.subcomponents.form_input.id}__input_${theme_id ?? ''}`"
        />

        <p v-if="errors['postcode']"  :class="`grid c_${component.subcomponents.form_input.id}__error c_${component.subcomponents.form_input.id}__error_${theme_id ?? ''}`" role="alert">
              {{ errors['postcode'] }}
        </p>
      </div>
    </div>

<!-- Quantity -->
  <div :class="`grid containable c_${component.id}__quantity c_${component.id}__quantity_${theme_id ?? ''}`">
        
    <div :class="`grid c_${component.subcomponents.quantity_input.id}__container c_${component.subcomponents.quantity_input.id}__container_${theme_id ?? ''}`">

      <span :class="`grid c_${component.subcomponents.quantity_input.id}__reduce_button c_${component.subcomponents.quantity_input.id}__reduce_button_${theme_id ?? ''} c_${component.subcomponents.quantity_input.subcomponents.button.id}__outer_container c_${component.subcomponents.quantity_input.subcomponents.button.id}__outer_container_${theme_id ?? ''}`">
        <button 
        :class="`c_${component.subcomponents.quantity_input.subcomponents.button.id}__button c_${component.subcomponents.quantity_input.subcomponents.button.id}__button_${theme_id ?? ''}`"
        @click="decreaseQuantity">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 172 172"
            style="fill:inherit;"
          >
            <g
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray=""
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal"
            >
              <path d="M0,172v-172h172v172z" fill="none"></path>
              <g fill="inherit">
                <path
                  d="M86,8.13074c-19.95469,0 -39.90938,7.59114 -55.09375,22.77551c-30.36875,30.36875 -30.36875,79.81875 0,110.1875c15.18437,15.18437 35.07188,22.84375 55.09375,22.84375c20.02188,0 39.90937,-7.65938 55.09375,-22.84375c30.36875,-30.36875 30.36875,-79.81875 0,-110.1875c-15.18438,-15.18437 -35.13906,-22.77551 -55.09375,-22.77551zM86,16.125c17.87188,0 35.7448,6.85208 49.45105,20.42395c27.27812,27.27812 27.27812,71.62187 0,98.76563c-27.27812,27.27812 -71.62187,27.27812 -98.76562,0c-27.27812,-27.14375 -27.28022,-71.4875 -0.13647,-98.76563c13.70625,-13.57187 31.57917,-20.42395 49.45105,-20.42395zM61.8125,81.96875c-2.28438,0 -4.03125,1.74688 -4.03125,4.03125c0,2.28437 1.74687,4.03125 4.03125,4.03125h51.0625c2.28437,0 4.03125,-1.74688 4.03125,-4.03125c0,-2.28437 -1.74688,-4.03125 -4.03125,-4.03125z"
                ></path>
              </g>
            </g>
          </svg>
        </button>
      </span>

      <span :class="`grid c_${component.subcomponents.quantity_input.id}__input c_${component.subcomponents.quantity_input.id}__input_${theme_id ?? ''}`">
        <div :class="`c_${component.subcomponents.quantity_input.subcomponents.form_input.id}__outer_container c_${component.subcomponents.quantity_input.subcomponents.form_input.id}__outer_container_${theme_id ?? ''}`">
          <input
            type="number"
            name="quantity"
            id="quantity"
            v-model.number="quantity"
            :class="`grid c_${component.subcomponents.quantity_input.subcomponents.form_input.id}__input c_${component.subcomponents.quantity_input.subcomponents.form_input.id}__input_${theme_id ?? ''}`"
          />
          <span
          :class="`grid c_${component.subcomponents.quantity_input.subcomponents.form_input.id}__error c_${component.subcomponents.quantity_input.subcomponents.form_input.id}__error_${theme_id ?? ''}`"
            role="alert"
            v-if="errors['quantity']"
          >
            {{ errors["quantity"] }}
          </span>
        </div>
      </span>

      <span :class="`grid c_${component.subcomponents.quantity_input.id}__increase_button c_${component.subcomponents.quantity_input.id}__increase_button_${theme_id ?? ''} c_${component.subcomponents.quantity_input.subcomponents.button.id}__outer_container c_${component.subcomponents.quantity_input.subcomponents.button.id}__outer_container_${theme_id ?? ''}`">
        <button 
        :class="`c_${component.subcomponents.quantity_input.subcomponents.button.id}__button c_${component.subcomponents.quantity_input.subcomponents.button.id}__button_${theme_id ?? ''}`"
        @click="increaseQuantity">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 172 172"
            style="fill:inherit;"
          >
            <g
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray=""
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal"
            >
              <path d="M0,172v-172h172v172z" fill="none"></path>
              <g fill="inherit">
                <path
                  d="M86,8.13074c-19.95469,0 -39.90938,7.59114 -55.09375,22.77551c-30.36875,30.36875 -30.36875,79.81875 0,110.1875c15.18437,15.18437 35.20625,22.84375 55.09375,22.84375c19.8875,0 39.90937,-7.65938 55.09375,-22.84375c30.36875,-30.36875 30.36875,-79.81875 0,-110.1875c-15.18438,-15.18437 -35.13906,-22.77551 -55.09375,-22.77551zM86,16.125c17.87188,0 35.7448,6.85208 49.45105,20.42395c27.14375,27.27812 27.14375,71.62397 0,98.9021c-27.27812,27.27812 -71.62187,27.27812 -98.76562,0c-27.27812,-27.27812 -27.28022,-71.62397 -0.13647,-98.9021c13.70625,-13.57187 31.57917,-20.42395 49.45105,-20.42395zM86,56.4375c-2.28437,0 -4.03125,1.74687 -4.03125,4.03125v21.5h-21.5c-2.28438,0 -4.03125,1.74688 -4.03125,4.03125c0,2.28437 1.74687,4.03125 4.03125,4.03125h21.5v21.5c0,2.28437 1.74688,4.03125 4.03125,4.03125c2.28437,0 4.03125,-1.74688 4.03125,-4.03125v-21.5h21.5c2.28437,0 4.03125,-1.74688 4.03125,-4.03125c0,-2.28437 -1.74688,-4.03125 -4.03125,-4.03125h-21.5v-21.5c0,-2.28438 -1.74688,-4.03125 -4.03125,-4.03125z"
                ></path>
              </g>
            </g>
          </svg>
        </button>
      </span>
    </div>
  </div>

  <!-- Add to Cart Button -->
    <div :class="`grid c_${component.id}__add_to_cart_button c_${component.id}__add_to_cart_button_${theme_id ?? ''} c_${component.subcomponents.button.id}__outer_container c_${component.subcomponents.button.id}__outer_container_${theme_id ?? ''}`">
      <button
        type="submit"
        :class="`c_${component.subcomponents.button.id}__button c_${component.subcomponents.button.id}__button_${theme_id ?? ''}`"
        :disabled="!showAddToCartButton"
        @click="addToCart"
      >
        Add to Cart
      </button>
    </div>

  <!-- Error message -->
    <div v-if="Object.keys(errors).length" :class="`grid c_${component.id}__error c_${component.id}__error_${theme_id ?? ''}`">
      Please address the problems above and then click add to cart again.
    </div>
    <div v-else></div>

  </div>
</template>

<script>
import Storer from "../services/storer";
import ImageService from "../services/imageService"
import FormInput from "./FormInput.vue";
import FormSelect from "./FormSelect.vue";
import Checkbox from "./Checkbox.vue";
import SelectionOptionInfo from "./SelectionOptionInfo.vue";
import StringDecoder from "../services/stringDecoder";
import CrossSaleProductCard from "./product/CrossSaleProductCard.vue";
import AddToWishList from "./AddToWishList.vue";
import StockStatus from "./shop/StockStatus.vue"
import ZipWidget from "./ZipWidget.vue";
import dayjs from "dayjs";

export default {
  components: {
    Checkbox,
    FormInput,
    FormSelect,
    SelectionOptionInfo,
    CrossSaleProductCard,
    AddToWishList,
    StockStatus,
    ZipWidget
  },
  props: {
    product: Object,
    company_name: String,
    status: Array,
    cross_sale_product_status: Object,
    page_settings: Object,
    transaction_settings: Object,
    component: Object,
    theme_id: Number,
  },
  data() {
    return {
      uuid: null,
      size: "1.8rem",
      colour: "#667679",
      selected_sku_id:
        this.product.order_quantity === 1
          ? this.product.current_skus.find((sku) =>
              this.status.some((s) =>
                s.some((st) => st.id == sku.id && st.status == "In Stock")
              )
            )?.id ??
            this.product.current_skus[0]?.id ??
            null
          : null,
      quantity: 1,
      customer_content: "",
      postcode: '',
      selected: this.product.order_quantity > 1 ? this.setSelected() : [],
      selection_options: this.setSelectionOptions(),
      purchase_addons: this.product.purchase_addons.map((pa) => {
        return {
          id: pa.id,
          name: pa.name,
          price: pa.pivot.price,
          selected: false,
        };
      }),
      cross_sale_products: this.product.cross_sale_products.map((csp) => {
        const product = csp.cross_sale_product;
        return {
          product: product,
          id: product.id,
          name: product.name,
          set: product.set,
          display_image_index: product.display_image_index,
          warehouses: product.warehouses,
          label_text: csp.label_text,
          skus: csp.cross_sale_product_skus.map((s) => s.sku),
          current_specials: product.current_specials,
          selected: false,
          selected_sku_id: product.set
            ? null
            : csp.cross_sale_product_skus[0]?.product_sku_id,
          images: product.images,
          customer_content: "",
          quantity: 1,
          price: null,
          regular_price: null,
          special_price: null,
          image_url: this.getImageUrl(product),
        };
      }),
      errors: {},
      status_info: `<p>Stock availability and location will affect shipping prices and collection options. We will endeavor to match your shipping address with the cheapest shipping options.</p><p><span class="text-orange-500">On Order</span> and <span class="text-orange-500">Preorder</span> items can be ordered now, but with a delay in delivery.</p><p>Please be aware that ETAs may change with the current disruption in global shipping.</p>`,
      // price:
      //   this.product.set || this.product.order_quantity > 1
      //     ? this.product.price
      //     : this.product.current_skus[0].price,
      // special:
      //   this.product.set || this.product.order_quantity > 1
      //     ? this.productSpecial()
      //     : this.skuSpecial(),
      // special_price:
      //   this.product.set || this.product.order_quantity > 1
      //     ? this.productSpecial()?.pivot.special_price ?? null
      //     : this.skuSpecial()?.pivot.special_price ?? null,
    };
  },
  computed: {
    cartName() {
      return `${this.company_name.replaceAll(" ", "_").toLowerCase()}_cart`
    },
    widgetPrice() {
      return ((this.special_price ? this.special_price : this.price) / 100).toFixed(2);
    },
    warehouses() {
      return this.product.set
        ? this.status.map((s) => {
            return {
              warehouse_id: s.warehouse_id,
              city: s.warehouse_city,
              status: s.status,
              eta: s.eta,
            };
          })
        : this.status.reduce((warehouses, s) => {
            const status = s.find((st) => st.id === this.selected_sku_id);
            warehouses.push({
              warehouse_id: s[0].warehouse_id,
              city: s[0].warehouse_city,
              status: status?.status ?? "",
              eta: status?.eta ?? "",
            });
            return warehouses;
          }, []);
    },
    showAddToCartButton() {
      return this.warehouses.some((w) => w.status != "Out of Stock");
    },
    selected_sku() {
      return this.product.current_skus?.find((sku) => sku.id === this.selected_sku_id);
    },
    selected_skus() {
      return this.selected.map((s) =>
        this.product.current_skus?.find((sku) => sku.id === s)
      );
    },
    price() {
      return this.useProductPrice
        ? this.product.price
        : this.selected_sku?.price;
    },
    useProductPrice() {
      return this.product.set || this.product.order_quantity > 1;
    },
    special() {
      return this.useProductPrice
        ? this.productSpecial()
        : this.selectedSkuSpecial;
    },
    // productSpecial() {
    //   return this.product.current_specials &&
    //     this.product.current_specials.length
    //     ? this.product.current_specials[0]
    //     : null;
    // },
    selectedSkuSpecial() {
      return this.selected_sku?.current_specials &&
        this.selected_sku?.current_specials.length
        ? this.selected_sku.current_specials[0]
        : null;
    },
    special_price() {
      return this.special?.pivot?.special_price ?? null;
    },
    stock_status() {
      if(this.warehouses.some(w => w.status === 'In Stock'))
      {
        return 'In Stock'
      } else if(this.warehouses.some(w => w.status === 'On Order'))
      {
        return 'On Order'
      } else if(this.warehouses.some(w => w.status === 'Preorder'))
      {
        return 'Preorder'
      } else {
        return 'Out of Stock'
      }
    },
    statusSpanClasses() {
      if(this.stock_status === 'In Stock')
      {
        return 'text-green-500 font-bold'
      } else if(this.stock_status === 'On Order')
      {
        return 'text-orange-500 font-bold'
      } else if(this.stock_status === 'Preorder')
      {
        return 'text-orange-500 font-bold'
      } else {
        return 'text-red-500 font-bold'
      }
    },
    eta() {
      return this.warehouses.filter(w => w.eta).sort((a,b) => {
        if (a < b) {
          return -1;
        } else if (a > b) {
          return 1;
        }
        return 0;
      })?.[0].eta
    }
  },
  watch: {


    special(special) {
      this.eventBus.emit("productSpecialModified", special);
    },
    selected_sku_id: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.selection_options.forEach((so, index) => {
            this.selection_options[index].selected =
              this.selected_sku?.selection_options.find((s) => s.id === so.id)
                ?.pivot.value ?? "";
          });
        });
      },
    },
  },
  methods: {
    productSpecial() {
      return this.product.current_specials &&
        this.product.current_specials.length
        ? this.product.current_specials[0]
        : null;
    },
    skuSpecial() {
      return this.product.current_skus[0].current_specials &&
        this.product.current_skus[0].current_specials.length
        ? this.product.current_skus[0].current_specials[0]
        : null;
    },
    expiryDate() {
      return dayjs(this.special.expires_at).format("dddd Do of MMMM");
    },
    formatPrice(price) {
      return (price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    colourBG(colours) {
      if (!colours) {
        return "";
      }
      const coloursArray = colours.split(",");
      const degree = 100 / coloursArray.length;
      return coloursArray.length == 1
        ? `background:${coloursArray[0]};`
        : coloursArray.reduce((gradient, colour, index) => {
            if (index == 0) {
              gradient += `${colour}, ${colour} ${degree}%,`;
            } else if (index == coloursArray.length - 1) {
              gradient += `${colour} ${degree * index}%);`;
            } else {
              gradient += `${colour} ${degree * index}%, ${colour} ${
                degree * (index + 1)
              }%,`;
            }
            return gradient;
          }, `background-image: linear-gradient(to right,`);
    },
    selectOption(index, so, value) {
      if (this.selected.length) {
        this.selection_options[index].find(
          (option) => option.id === so.id
        ).selected = value;
      } else {
        this.selection_options.find((option) => option.id === so.id).selected =
          value;
      }
      this.setSelectedSkuId();
    },
    selectSku(i) {
      if (this.selected.length) {
        this.selection_options[i].forEach((so, index) => {
          this.selection_options[i][index].selected =
            this.product.current_skus
              .find((sku) => sku.id === this.selected[i])
              ?.selection_options.find((s) => s.id === so.id)?.pivot.value ??
            "";
        });
      } else {
      }
    },
    setSelected() {
      const selected = [];
      for (let index = 0; index < this.product.order_quantity; index++) {
        selected.push(null);
      }
      return selected;
    },
    setSelectionOptions() {
      if (this.product.order_quantity > 1) {
        const selectionOptions = [];
        for (let index = 0; index < this.product.order_quantity; index++) {
          selectionOptions.push(this.buildSelectionOptions());
        }
        return selectionOptions;
      } else {
        return this.buildSelectionOptions();
      }
    },
    buildSelectionOptions() {
      return this.product.selection_options.reduce((options, so) => {
        let sortFormula;
        if (so.pivot.sort_pattern) {
          sortFormula = (a, b) => {
            const pattern = new RegExp(so.pivot.sort_pattern);
            const aMatch = a.match(pattern);
            const bMatch = b.match(pattern);
            const aSort = aMatch ? aMatch[0] : "";
            const bSort = bMatch ? bMatch[0] : "";
            const sortAsNumber = !isNaN(aSort) && !isNaN(bSort);
            if (sortAsNumber) {
              return aSort - bSort;
            } else {
              if (aSort < bSort) {
                return -1;
              }
              if (aSort > bSort) {
                return 1;
              }
              return 0;
            }
          };
        } else {
          sortFormula = (a, b) => {
            if (a < b) {
              return -1;
            }
            if (a > b) {
              return 1;
            }
            return 0;
          };
        }

        options.push({
          id: so.id,
          name: so.name,
          info: so.pivot.info ? StringDecoder.decode(so.pivot.info) : "",
          selected: null,
          values: this.product.current_skus
            .reduce((uniqueValues, sku) => {
              const value =
                sku.selection_options.find((s) => s.id === so.id)?.pivot
                  .value ?? "";
              if (!uniqueValues.includes(value)) {
                uniqueValues.push(value);
              }
              return uniqueValues;
            }, [])
            .sort(sortFormula),
        });
        return options;
      }, []);
    },
    setSelectedSkuId() {
      if (this.selected.length) {
        this.selected.forEach((s, index) => {
          this.selected[index] = this.product.current_skus.find((sku) =>
            sku.selection_options.reduce((isSku, so) => {
              isSku = this.selection_options[index].some(
                (option) =>
                  option.id === so.id && option.selected === so.pivot.value
              )
                ? isSku
                : false;
              return isSku;
            }, true)
          )?.id;
        });
      } else {
        this.selected_sku_id = this.product.current_skus.find((sku) =>
          sku.selection_options.reduce((isSku, so) => {
            isSku = this.selection_options.some(
              (option) =>
                option.id === so.id && option.selected === so.pivot.value
            )
              ? isSku
              : false;
            return isSku;
          }, true)
        )?.id;
      }
    },
    decreaseQuantity() {
      this.quantity = this.quantity === 1 ? 1 : (this.quantity -= 1);
    },
    increaseQuantity() {
      this.quantity++;
    },
    validate() {
      this.errors = {};
      if (!this.postcode) {
        this.errors["postcode"] = "Please enter your postcode to help us put the right items in your cart";
      }
      else if(this.postcode.length != 4 || isNaN(parseInt(this.postcode)) || parseInt(this.postcode) > 9999) {
        this.errors["postcode"] = "Please enter a valid postcode to help us put the right items in your cart";
      }
      if (this.quantity < 1 || isNaN(this.quantity)) {
        this.errors["quantity"] = "Please enter a valid amount";
      }
      if(this.product.requires_customer_input && !this.customer_content) {
        this.errors["customer_content"] = "Your input is required";
      }
      if (this.product.order_quantity > 1) {
        if (this.selected.includes(null)) {
          this.errors[
            "selected"
          ] = `Please select ${this.product.order_quantity} options`;
        }
      } else {
        if (!this.product.set && !this.selected_sku_id) {
          this.errors["selected_sku_id"] = "Please select an option";
        }
      }
      this.cross_sale_products
        .filter((csp) => csp.selected)
        .forEach((csp) => {
          console.log("CSP: ", csp)
          if(csp.product.requires_customer_input && !csp.customer_content) {
            this.errors[`cross_sale_products${csp.id}`] = `Your input is required`;
          }
        })
      return !Object.keys(this.errors).length;
    },
    addToCart() {
      if (!this.validate()) {
        return;
      }
      this.show_spinner = true
      this.messages = []
      axios({
        method: "post",
        url: "/cart",
        data: {
          uuid: this.uuid,
          postcode: this.postcode,
          cross_sale_products: this.cross_sale_products.filter((csp) => csp.selected).map(csp => ({
            product_id: csp.id,
            product_sku_id: csp.selected_sku_id,
            quantity: csp.quantity,
            customer_content: csp.customer_content,
            purchase_addons: [],
          })),
          product_id: this.product.id,
          product_sku_id: this.selected_sku_id,
          product_skus: this.selected.length ? this.selected : null,
          quantity: this.quantity,
          customer_content: this.customer_content,
          purchase_addons: this.purchase_addons.filter((pa) => pa.selected).map(pa => pa.id)
        },
      })
        .then((response) => {
          Storer.store(this.cartName, {postcode: this.postcode, ...response.data.cart})
          this.uuid = response.data.cart.uuid
          this.messages = Object.values(response.data.messages)
          console.log(response)
          this.eventBus.emit("cartModified");
          this.eventBus.emit("flashMessage", {
            message: `${this.product.name} added to cart`,
            error: false,
          });
          this.registerAddToCart();
          this.show_spinner = false
        })
        .catch((error) => {
          console.error(error)
          if (error.response.status === 422) {
            this.errors = Object.keys(error.response.data.errors).reduce(
              (errors, key) => {
                errors[key] = error.response.data.errors[key][0];
                return errors;
              },
              {}
            );
            this.error_message =
              "Please correct the errors in the form and try again";
          } else if (error.response.status === 500) {
          } else if (error.response.status === 503) {
            this.error_message = error.response.data.message;
          }
          this.show_spinner = false;
        });
      },
    addCrossSaleProductsToCart() {
      this.cross_sale_products
        .filter((csp) => csp.selected)
        .forEach((csp) => {
          const warehouses = this.getCrossSaleWarehouses(csp);

          Storer.addToStoredArray(this.cartName, {
            product_id: csp.id,
            product_name: csp.name,
            product_slug: csp.slug,
            set: csp.set,
            product_skus: [],
            collectable_warehouses: csp.warehouses
              .filter(
                (pw) =>
                  pw.pivot.collectable &&
                  warehouses.some(
                    (w) => w.warehouse_id == pw.id && w.status != "Out of Stock"
                  )
              )
              .map((pw) => pw.id),
            shippable_warehouses: csp.warehouses
              .filter(
                (pw) =>
                  pw.pivot.shippable &&
                  warehouses.some(
                    (w) => w.warehouse_id == pw.id && w.status != "Out of Stock"
                  )
              )
              .map((pw) => pw.id),
            warehouses: warehouses,
            transportation_company_id: csp.set
              ? csp.transportation_company_id
              : csp.current_skus.find((sku) => sku.id == csp.selected_sku_id)
                  .transportation_company_id,
            product_sku_id: csp.selected_sku_id,
            product_sku_code: csp.set ? '' : csp.current_skus.find((s) => s.id == csp.selected_sku_id).sku_code,
            product_sku_name: csp.set ? '' : csp.current_skus.find((s) => s.id == csp.selected_sku_id).display_name,
            price: csp.price,
            regular_price: csp.regular_price,
            special_price: csp.special_price,
            on_special: csp.special_price ? true : false,
            quantity: csp.quantity,
            customer_content: csp.customer_content,
            purchase_addons: [],
            image_url: this.getImageUrl(csp.product),
          });
        });
    },
    getCrossSaleWarehouses(product) {
      return product.set
        ? this.cross_sale_product_status[product.id].map((s) => {
            return {
              warehouse_id: s.warehouse_id,
              city: s.warehouse_city,
              status: s.status,
              eta: s.eta,
            };
          })
        : this.cross_sale_product_status[product.id].reduce((warehouses, s) => {
            const status = s.find((st) => st.id === product.selected_sku_id);
            warehouses.push({
              warehouse_id: s[0].warehouse_id,
              city: s[0].warehouse_city,
              status: status?.status ?? "",
              eta: status?.eta ?? "",
            });
            return warehouses;
          }, []);
    },
    getImageUrl(product) {
      let index = product.display_image_index ? product.display_image_index : 0;

      return product.images && product.images.length && index in product.images
        ? ImageService.url(product.images[index], 'thumbnail')
        : null;
    },
    registerAddToCart() {
      const item = {
        product_id: this.product.id,
        product_name: this.product.name,
        product_sku: this.selected_sku?.display_name,
        catalogue_id: this.selected_sku ? this.selected_sku.sku_code : this.product.slug
      }
      
      const price = parseFloat(((this.special_price ? this.special_price : this.price) / 100).toFixed(2))
      
      analyser.addToCart(item, this.quantity, price)
    },
  },
  mounted() {
    const cart = Storer.retrieve(this.cartName) ?? {};
    this.uuid = cart?.uuid
    this.postcode = cart?.postcode
  },
};
</script>